import { useState, useEffect } from 'react';

// Hook for debouncing
const useDebouncedValue = (value: string, delay: number) => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
};

export const useTemplateFilters = () => {
  const [searchInput, setSearchInput] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('');
  const [statusFilter, setStatusFilter] = useState<string>('all');

  const debouncedSearchTerm = useDebouncedValue(searchInput, 500);

  const activeFiltersCount = [
    debouncedSearchTerm,
    selectedCategory,
    statusFilter !== 'all'
  ].filter(Boolean).length;

  const handleClearFilters = () => {
    setSearchInput('');
    setSelectedCategory('');
    setStatusFilter('all');
  };

  return {
    searchInput,
    setSearchInput,
    selectedCategory,
    setSelectedCategory,
    statusFilter,
    setStatusFilter,
    debouncedSearchTerm,
    activeFiltersCount,
    handleClearFilters
  };
};